import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-position-center uk-text-center uk-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("h2", null, "Thank you!", -1),
    _createElementVNode("h3", { class: "uk-width-2-3 uk-align-center" }, " Your onboarding is complete, and the forms have been sent to the broker. You can close this page. ", -1),
    _createElementVNode("h4", { class: "uk-width-2-3 uk-align-center" }, [
      _createTextVNode(" If you'd like to use Duplex for onboarding other companies yourself, then please contact us at "),
      _createElementVNode("a", { href: "mailto: team@duplexhq.com" }, "team@duplexhq.com"),
      _createTextVNode(" to get an account and try it out! It's the "),
      _createElementVNode("b", null, "simplest"),
      _createTextVNode(" way to digitally onboard your partners. ")
    ], -1)
  ]))]))
}